/**
 * Keeps the navigation store's current path in sync on every route change (drives the active-nav-item
 * highlight via its getters) and clears each overview's search parameters when the visitor switches
 * language. The overview stores are resolved lazily since the reset only runs on a client-side locale
 * switch.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const navigationStore = useNavigationStore()

  router.afterEach((to, from) => {
    navigationStore.setRoute(to)

    // Route names are suffixed with the locale (e.g. `slug___nl`); reset when it changes.
    const fromLocale = from?.name?.toString().match(/___([a-z]{2})$/)?.[1]
    const toLocale = to?.name?.toString().match(/___([a-z]{2})$/)?.[1]
    if (fromLocale && toLocale && fromLocale !== toLocale) {
      useDiscoveryOverviewStore().reset()
      useEventOverviewStore().reset()
      useSearchStore().reset()
      useSeriesOverviewStore().reset()
    }
  })
})
